<template>
  <div class="alarm-control-dialog">
    <gs-modal
      v-model="visible"
      :before-close="beforeClose"
      :before-confirm="beforeConfirm"
      :title="isEdit?name+'-报警控制':'新建'+'-报警控制'"
      :has-form="true"
      class="alarm-control-dialog-modal"
      width="50%"
      top="5%"
      @close="close"
      @cancel="close"
      @confirm="handleConfirm"
    >
      <gs-tabs
        v-model="activeName"
        type="content-tab"
      >
        <gs-tab-pane
          label="常规"
          name="General"
        >
          <div class="general-form">
            <gs-form
              label-width="100px"
              label-position="left"
              gap="small"
            >
              <gs-form-item
                label="名称"
                prop="name"
              >
                <gs-input
                  ref="nameInput"
                  v-model="name"
                />
              </gs-form-item>

              <gs-form-item
                label="描述"
                prop="Description"
              >
                <gs-input v-model="description"/>
              </gs-form-item>

              <gs-form-item
                label="报警接收者"
                prop="alarmReceiver"
                style="margin-bottom:0px"
              />
              <div class="form-item-alarmReceiverList">
                <gs-table
                  :data="form.alarmReceiver"
                  :height="170"
                  style="width: 100%"
                  @row-dblclick="openDetail"
                  @select="getSelection"
                  @select-all ="getSelection"
                >
                  <gs-table-column
                    type="selection"
                    fixed
                  />
                  <gs-table-column
                    prop="name"
                    label="名称"
                  />
                  <gs-table-column
                    prop="type"
                    label="类型"
                  />
                </gs-table>
              </div>
              <div class="bottom-btn">
                <gs-button @click="addAlarmReceiver(1)">增加</gs-button>
                <gs-button @click="openDetail">属性</gs-button>
                <gs-button @click="delAlarmReceiver(1)">删除</gs-button>
              </div>
            </gs-form>
          </div>
        </gs-tab-pane>
        <gs-tab-pane
          label="报警确认"
          name="acknowledge"
        >
          <div class="alarm-form">
            <gs-form
              label-width="100px"
              label-position="left"
              gap="small"
            >
              <!-- <div class="checkbox">
                <div><gs-checkbox v-model="form.checked1">发送确认事件给报警接收者</gs-checkbox></div>
                <div><gs-checkbox v-model="form.checked2">强制确认</gs-checkbox></div>
                <div><gs-checkbox v-model="form.checked3">强制带签名的确认</gs-checkbox></div>
              </div> -->
              <fieldset>
                <legend>确认超时</legend>
                <gs-form-item
                  label="超时时间"
                  prop="acknowledgeTimeout"
                  label-width="100px"
                  style="margin-right:24px"
                >
                  <gs-time-picker
                    v-model="form.acknowledgeTimeout"
                    :default-time="defaultTime"
                    input-type="input"
                    format="HH:mm"
                  />
                </gs-form-item>
                <gs-form-item
                  label="其他报警接收者"
                  prop="alarmReceiver"
                >
                  <gs-input
                    v-model="showAlarmReceiver"
                    :disabled="form.acknowledgeTimeout === null||showAlarmReceiver===''"
                    style="width:84%"
                  />
                  <gs-button
                    :disabled="form.acknowledgeTimeout === null"
                    @click="addAlarmReceiver(2)"
                  >...</gs-button>
                </gs-form-item>
              </fieldset>
            </gs-form>
          </div>
        </gs-tab-pane>

        <gs-tab-pane
          label="时间设置"
          name="timeControl"
        >
          <div class="object-form">
            <gs-form
              label-width="100px"
              label-position="left"
              gap="small"
            >
              <gs-form-item
                label="时间变量"
                prop="timeVariable"
              >
                <gs-input
                  v-model="showTimeChart"
                  :disabled="showTimeChart===''"
                  style="width:84%"
                />
                <gs-button @click="addTimeChart">...</gs-button>
              </gs-form-item>
              <gs-form-item
                label="选择报警接收者"
                prop="alarmReceiver"
                style="margin-bottom:0px"
              />
              <div class="form-item-alarmReceiverList">
                <gs-table
                  :data="form.variableReceiver"
                  :height="170"
                  style="width: 100%"
                  @row-dblclick="openDetail"
                  @select="getSelection"
                  @select-all ="getSelection"
                >
                  <gs-table-column
                    type="selection"
                    fixed
                  />
                  <gs-table-column
                    prop="name"
                    label="名称"
                  />
                  <gs-table-column
                    prop="type"
                    label="类型"
                  />
                </gs-table>
              </div>
              <div class="bottom-btn">
                <gs-button @click="addAlarmReceiver(3)">增加</gs-button>
                <gs-button @click="openDetail">属性</gs-button>
                <gs-button @click="delAlarmReceiver(3)">删除</gs-button>
              </div>
            </gs-form>
          </div>
        </gs-tab-pane>
        <gs-tab-pane
          label="用户"
          name="user"
        >
          <div class="user-form">
            <gs-form
              label-width="150px"
              label-position="left"
              gap="small"
            >
              <gs-form-item
                label="选择接收报警的用户组"
                prop="alarmUserGroup"
                style="margin-bottom:0px"
              />
              <div class="form-item-alarmReceiverList">
                <gs-table
                  :data="form.alarmUserGroup"
                  :height="170"
                  style="width: 100%"
                  @row-dblclick="openDetail"
                  @select="getSelection"
                  @select-all ="getSelection"
                >
                  <gs-table-column
                    type="selection"
                    fixed
                  />
                  <gs-table-column
                    prop="name"
                    label="名称"
                  />
                  <gs-table-column
                    prop="type"
                    label="类型"
                  />
                </gs-table>
              </div>
              <div class="bottom-btn">
                <gs-button @click="addUserGroup">增加</gs-button>
                <gs-button @click="openDetail">属性</gs-button>
                <gs-button @click="delUserGroup">删除</gs-button>
              </div>
            </gs-form>
          </div>
        </gs-tab-pane>
      </gs-tabs>
    </gs-modal>
    <gs-modal
      v-model="visibleAlarmReceiver1"
      class="alarmReceiver-select"
      title="添加报警接收者"
      @close="closeAlarmReceiver(1)"
      @confirm="handleConfirmAlarmReceiver(1)"
    >
      <div class="treeList">
        <gs-tree
          v-if="visibleAlarmReceiver1"
          ref="tree"
          :data="dataList"
          :props="props"
          :disable-node="true"
          :leaf-checkbox-only="true"
          :node-key="'id'"
          show-checkbox
          @check-change="checkEvent"
        />
      </div>
    </gs-modal>
    <gs-modal
      v-model="visibleAlarmReceiver2"
      class="alarmReceiver-select"
      title="添加报警接收者"
      @close="closeAlarmReceiver(2)"
      @confirm="handleConfirmAlarmReceiver(2)"
    >
      <div class="treeList">
        <gs-tree
          v-if="visibleAlarmReceiver2"
          ref="tree"
          :data="dataList"
          :props="props"
          :disable-node="true"
          :leaf-checkbox-only="true"
          :node-key="'id'"
          show-checkbox
          @check-change="checkEvent"
        />
      </div>
    </gs-modal>
    <gs-modal
      v-model="visibleAlarmReceiver3"
      class="alarmReceiver-select"
      title="添加报警接收者"
      @close="closeAlarmReceiver(3)"
      @confirm="handleConfirmAlarmReceiver(3)"
    >
      <div class="treeList">
        <gs-tree
          v-if="visibleAlarmReceiver3"
          ref="tree"
          :data="dataList"
          :props="props"
          :disable-node="true"
          :leaf-checkbox-only="true"
          :node-key="'id'"
          show-checkbox
          @check-change="checkEvent"
        />
      </div>
    </gs-modal>
    <gs-modal
      v-model="visibleTimeChart"
      :before-close="beforeCloseTimeChart"
      class="alarmReceiver-select"
      title="添加时间表"
      @close="closeTimeChart"
      @confirm="handleConfirmTimeChart"
    >
      <div class="treeList">
        <gs-tree
          v-if="visibleTimeChart"
          ref="tree"
          :data="dataList"
          :props="props"
          :disable-node="true"
          :leaf-checkbox-only="true"
          :node-key="'id'"
          show-checkbox
          @check-change="checkEvent"
        />
      </div>
    </gs-modal>
    <gs-modal
      v-model="visibleUserGroup"
      :before-close="beforeCloseUserGroup"
      class="alarmReceiver-select"
      title="添加报警用户组"
      @close="closeUserGroup"
      @confirm="handleConfirmUserGroup"
    >
      <div class="treeList">
        <gs-tree
          v-if="visibleUserGroup"
          ref="tree"
          :data="dataList"
          :props="props"
          :disable-node="true"
          :leaf-checkbox-only="true"
          :node-key="'id'"
          show-checkbox
          @check-change="checkEvent"
        />
      </div>
    </gs-modal>
  </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex'
import service from '../../service/leftService.js'
import moment from 'moment'
export default {
  data () {
    return {
      objectInfo: {},
      isEdit: false,
      activeName: 'General',
      name: '',
      description: '',
      props: {
        label: 'name',
        disabled: 'type:folder'
      },
      form: {
        alarmReceiver: [],
        acknowledgeTimeout: null,
        timeoutReceiver: null,
        timeVariable: null,
        variableReceiver: [],
        alarmUserGroup: []
      },
      visibleAlarmReceiver1: false,
      visibleAlarmReceiver2: false,
      visibleAlarmReceiver3: false,
      visibleTimeChart: false,
      visibleUserGroup: false,
      dataList: [],
      selection: [],
      showAlarmReceiver: '',
      showTimeChart: '',
      defaultTime: moment()
    }
  },
  computed: {
    ...mapState({
      visible: 'alarmControlShow',
      objectData: 'objectInfo',
      nodeData: 'nodeTree'
    })
  },
  watch: {
    'form.timeoutReceiver': function () {
      this.showAlarmReceiver = this.form.timeoutReceiver ? this.form.timeoutReceiver.fullName : ''
    },
    'form.timeVariable': function () {
      this.showTimeChart = this.form.timeVariable ? this.form.timeVariable.fullName : ''
    },
    showAlarmReceiver () {
      if (this.form.timeoutReceiver && this.showAlarmReceiver !== this.form.timeoutReceiver.fullName) {
        this.form.timeoutReceiver = null
      }
    },
    showTimeChart () {
      if (this.form.timeVariable && this.showTimeChart !== this.form.timeVariable.fullName) {
        this.form.timeVariable = null
      }
    },
    tableData () {
      this.form.objList = this.tableData
    },
    visible () {
      if (this.visible) {
        this.activeName = 'General'
        this.objectInfo = this.objectData
        setTimeout(() => {
          this.$refs.nameInput.focus()
        }, 100)
        if (JSON.stringify(this.objectInfo) !== '{}' && this.objectInfo.type === 'alarmControl') {
          this.form = this.objectInfo.attribute ? this.objectInfo.attribute : {}
          this.description = this.objectInfo.description ? this.objectInfo.description : ''
          this.name = this.objectInfo.name ? this.objectInfo.name : ''
          this.form.acknowledgeTimeout = moment(this.form.acknowledgeTimeout)
          this.isEdit = true
        } else {
          this.form = {
            alarmReceiver: [],
            timeoutReceiver: null,
            timeVariable: null,
            variableReceiver: [],
            alarmUserGroup: []
          }
          this.description = ''
          this.name = ''
          this.isEdit = false
        }
      }
    }
  },
  methods: {
    ...mapMutations({
      close: 'ALARM_CONTROL_HIDE',
      showSelectDialog: 'SELECT_DIALOG_SHOW',
      needReload: 'NEED_RELOAD_TREE',
      alarmChartDialogShow: 'ALARMCHART_PROPERTIES_DIALOG_SHOW',
      userGroupAlarmShow: 'GROUP_ALARM_SHOW'
    }),
    beforeConfirm (e, done) {
      if (this.name === null || this.name === '') {
        this.$Message.warning('名称不能为空!')
        return
      }
      // done(false)可以阻止modal关闭
      done()
    },
    handleConfirm () {
      // 报警接收者只传id
      if (this.form.alarmReceiver != null && this.form.alarmReceiver.length > 0) {
        this.form.alarmReceiver.forEach((value, index, array) => {
          value = value.id
          array.splice(index, 1, value)
        })
      }
      // 超时时间接收者只传id
      if (this.form.timeoutReceiver != null) {
        this.form.timeoutReceiver = this.form.timeoutReceiver.id
      }
      // 时间变量只传id
      if (this.form.timeVariable != null) {
        this.form.timeVariable = this.form.timeVariable.id
      }
      // 符合变量条件的接收者只传id
      if (this.form.variableReceiver != null && this.form.variableReceiver.length > 0) {
        this.form.variableReceiver.forEach((value, index, array) => {
          value = value.id
          array.splice(index, 1, value)
        })
      }
      // 接收报警的用户或用户组只传id
      if (this.form.alarmUserGroup != null && this.form.alarmUserGroup.length > 0) {
        this.form.alarmUserGroup.forEach((value, index, array) => {
          value = value.id
          array.splice(index, 1, value)
        })
      }
      // 将时间对象转换成毫秒值
      if (this.form.acknowledgeTimeout != null) {
        this.form.acknowledgeTimeout = this.form.acknowledgeTimeout.valueOf()
      }
      if (this.objectInfo.id && this.objectInfo.type === 'alarmControl') {
        let param = {
          'id': this.objectInfo.id,
          'name': this.name,
          'type': this.objectInfo.type,
          'value': this.objectInfo.value,
          'parentId': this.objectInfo.parentId,
          'description': this.description,
          'attribute': this.form
        }
        service.renamePoint(param).then(res => {
          this.$Message.success('修改成功')
          this.close()
        }).catch(err => {
          console.log(err)
          //this.$Message.error(err.message)
        })
      } else {
        let param = {
          'name': this.name,
          'type': 'alarmControl',
          'parentId': this.objectInfo.id,
          'description': this.description,
          'attribute': this.form
        }
        console.log(param)
        service.newAddPoint(param).then(res => {
          this.$Message.success('添加成功')
          this.close()
        }).catch(err => {
          this.$Message.error(err.message)
        })
      }
    },
    beforeClose (e, done) {
      // done(false)可以阻止modal关闭
      this.close()
    },
    addAlarmReceiver (input) {
      this.dataList = []
      let _this = this
      switch (input) {
        case 1:
          this.visibleAlarmReceiver1 = true
          service.getTree('Receiver').then(res => {
            if (res[0] !== null) {
              this.dataList = res
            }
            if (_this.form.alarmReceiver !== null && _this.form.alarmReceiver.length > 0) {
              setTimeout(() => {
                _this.form.alarmReceiver.forEach(res => {
                  _this.$refs.tree.setChecked(res.id, true)
                })
              }, 0)
            }
          })
          break
        case 2:
          this.visibleAlarmReceiver2 = true
          service.getTree('Receiver').then(res => {
            if (res[0] !== null) {
              this.dataList = res
            }
            if (this.form.timeoutReceiver !== null) {
              setTimeout(() => {
                _this.$refs.tree.setChecked(this.form.timeoutReceiver.id, true)
              }, 0)
            }
          })
          break
        case 3:
          this.visibleAlarmReceiver3 = true
          service.getTree('Receiver').then(res => {
            if (res[0] !== null) {
              this.dataList = res
            }
            if (_this.form.variableReceiver !== null && _this.form.variableReceiver.length > 0) {
              setTimeout(() => {
                _this.form.variableReceiver.forEach(res => {
                  _this.$refs.tree.setChecked(res.id, true)
                })
              }, 0)
            }
          })
          break

        default:
          break
      }
    },
    addTimeChart () {
      this.dataList = []
      let _this = this
      this.visibleTimeChart = true
      service.getTree('TimeChart').then(res => {
        if (res[0] !== null) {
          this.dataList = res
        }
        if (this.form.timeVariable !== null) {
          setTimeout(() => {
            _this.$refs.tree.setChecked(this.form.timeVariable.id, true)
          }, 0)
        }
      })
    },
    addUserGroup () {
      this.dataList = []
      let _this = this
      this.visibleUserGroup = true
      service.getTree('UserGroupAlarm').then(res => {
        if (res[0] !== null) {
          this.dataList = res
        }
        if (_this.form.alarmUserGroup !== null && _this.form.alarmUserGroup.length > 0) {
          setTimeout(() => {
            _this.form.alarmUserGroup.forEach(res => {
              _this.$refs.tree.setChecked(res.id, true)
            })
          }, 0)
        }
      })
    },
    delAlarmReceiver (input) {
      if (this.selection === null || this.selection.length === 0) {
        this.$Message.warning('请至少选择一项')
        return
      }
      switch (input) {
        case 1:
          this.selection.forEach((value, index, array) => {
            this.form.alarmReceiver = this.form.alarmReceiver.filter(e => {
              return e.id !== value.id
            })
          })
          break
        case 3:
          this.selection.forEach((value, index, array) => {
            this.form.variableReceiver = this.form.variableReceiver.filter(e => {
              return e.id !== value.id
            })
          })
          break

        default:
          break
      }
    },
    delUserGroup () {
      if (this.selection === null || this.selection.length === 0) {
        this.$Message.warning('请至少选择一项')
        return
      }
      this.selection.forEach((value, index, array) => {
        this.form.alarmUserGroup = this.form.alarmUserGroup.filter(e => {
          return e.id !== value.id
        })
      })
    },
    closeAlarmReceiver (input) {
      switch (input) {
        case 1:
          this.visibleAlarmReceiver1 = false
          break
        case 2:
          this.visibleAlarmReceiver2 = false
          break
        case 3:
          this.visibleAlarmReceiver3 = false
          break

        default:
          break
      }
    },
    beforeCloseTimeChart () {
      this.visibleTimeChart = false
    },
    closeTimeChart () {
      this.visibleTimeChart = false
    },
    beforeCloseUserGroup () {
      this.visibleUserGroup = false
    },
    closeUserGroup () {
      this.visibleUserGroup = false
    },
    checkEvent (node, isSelect, halfSelect) {
      // console.log(node)
      // console.log(isSelect)
      // console.log(halfSelect)
      // if (node.type !== 'alarmReceiverEmail' && node.type !== 'timeChart' && node.type !== 'userGroupAlarm') {
      //   console.log(node)
      //   this.$Message.error('此节点为目录，无法被选择')
      //   this.$refs.tree.setChecked(node.id, false)
      // }
    },
    getSelection (selection, row) {
      this.selection = selection
    },
    openDetail (row, event) {
      if (event) {
        this.$store.state.objectInfo = row
      } else {
        if (this.selection.length !== 1) {
          this.$Message.warning('只能勾选一项')
          return
        }
        this.$store.state.objectInfo = this.selection[0]
      }
      switch (this.$store.state.objectInfo.type) {
        case 'alarmReceiverEmail':
          this.alarmChartDialogShow()
          break
        case 'userGroupAlarm':
          this.userGroupAlarmShow()
          break
        default:
          break
      }
    },
    handleConfirmAlarmReceiver (input) {
      let _this = this
      switch (input) {
        case 1:
          this.$refs.tree.getCheckedNodes(true).forEach(e => {
            _this.form.alarmReceiver.push(e.data)
          })
          this.form.alarmReceiver = this.unique(this.form.alarmReceiver, 'id')
          this.visibleAlarmReceiver1 = false
          break
        case 2:
          let array = this.$refs.tree.getCheckedNodes(true)
          if (array != null && array.length > 1) {
            this.$Message.warning('最多只能选择一个')
            return
          }
          this.form.timeoutReceiver = array[0].data
          this.visibleAlarmReceiver2 = false
          break
        case 3:
          this.$refs.tree.getCheckedNodes(true).forEach(e => {
            _this.form.variableReceiver.push(e.data)
          })
          this.form.variableReceiver = this.unique(this.form.variableReceiver, 'id')
          this.visibleAlarmReceiver3 = false
          break

        default:
          break
      }
    },
    handleConfirmTimeChart () {
      let array = this.$refs.tree.getCheckedNodes(true)
      if (array != null && array.length > 1) {
        this.$Message.warning('最多只能选择一个')
        return
      }
      this.form.timeVariable = array[0].data
      this.visibleTimeChart = false
    },
    handleConfirmUserGroup () {
      let _this = this
      this.$refs.tree.getCheckedNodes(true).forEach(e => {
        _this.form.alarmUserGroup.push(e.data)
      })
      this.form.alarmUserGroup = this.unique(this.form.alarmUserGroup, 'id')
      this.visibleUserGroup = false
    },
    unique (arr, name) {
      var hash = {}
      return arr.reduce(function (item, next) {
        hash[next[name]] ? '' : hash[next[name]] = true && item.push(next)
        return item
      }, [])
    }
  }
}
</script>
<style lang="scss">
.alarm-control-dialog {
  &-modal {
    .gs-select {
      width: 70%;
    }
    fieldset {
      padding: 12px;
      border-radius: 5px;
      border: solid 2px #d9d9d9
    }
    .gs-radio-group {
      line-height: 24px;
    }
    .limit {
      display: flex;
      width: 100%
    }
    .page-checkbox {
      margin-bottom: 24px
    }
    .form-item-alarmReceiverList {
      height: 200px;
      overflow: auto;
      margin-bottom: 12px;
      padding: 12px;
      border: solid 1px #d9d9d9;
      border-radius: 1px;
    }
    .checkbox {
      margin-bottom: 12px
    }
    .bottom-btn {
      text-align: center
    }
    .gs-tabs-content {
      position: static;
      overflow: hidden;
      padding: 16px 0;
    }
  }
}
.treeList {
      height: 300px;
      overflow: auto;
      margin-bottom: 12px;
      padding: 12px;
      border: solid 1px #d9d9d9;
      border-radius: 1px;
}

</style>



// WEBPACK FOOTER //
// src/components/alarm/alarmControl.vue